import sftpEditTemplate from './sftp-edit.html';
/* REDUX */
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { updateSftpById, fetchSftpById } from 'report-subscriptions/actions/sftp.actions';
import { fetchSftpAuthenticationTypesDictionary } from 'app/actions/dictionaries/sftp-authentication-types.actions';

const DIRTY_FORM = 'sftpEdit';

const mapStateToThis = ({ dictionary, sftp }) => {
  const { sftpAuthenticationTypes } = dictionary;
  const { selectedEntry } = sftp;

  return {
    selectedEntry,
    authenticationTypes: sftpAuthenticationTypes,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  updateSftpById,
  fetchSftpById,
  fetchSftpAuthenticationTypesDictionary,
};

@Inject('$ngRedux', 'gettextCatalog', '$state', 'Notifications', '$stateParams')
class SftpEditController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.fileErrors = {};
    this.DIRTY_FORM = DIRTY_FORM;
    this.enabledSelectOptions = [
      {
        label: this.gettextCatalog.getString('No'),
        value: false,
      },
      {
        label: this.gettextCatalog.getString('Yes'),
        value: true,
      },
    ];

    await Promise.all[
      this.fetchSftpAuthenticationTypesDictionary(), 
      this.fetchSftpById(this.$stateParams.configId)
    ];

    this.enabled = this.selectedEntry.enabled;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async submitForm(form) {
    form.$setSubmitted();

    if (form.$invalid) return;

    const { passwordSet, ...configuration } = this.selectedEntry;

    await this.updateSftpById(configuration);

    this.setDirtyForm(DIRTY_FORM, false);
    this.Notifications.alertSuccess(this.gettextCatalog.getString('Configuration has been edited'));
    this.$state.go('sftp-view', { skipDirtyForms: true });
  }
}

export default class SftpEditComponent {
  constructor() {
    this.template = sftpEditTemplate;
    this.controller = SftpEditController;
    this.bindings = {
      model: '<',
      retailerId: '@',
      api: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/components/management/sftp/sftp-edit/sftp-edit-component.js